import React, { useState, FC } from 'react';

import { useStore } from '@vromo/mobx-react/mobx-react';
import { RootStore } from '../stores/RootStore';
import { Job } from '@vromo/models';
import { update } from 'serializr';
import { format } from 'date-fns';
import Modal from '@vromo/ui/components/Modal';
import Button from '@vromo/ui/components/Button';
import theme from '@vromo/ui/components/theme';

import Tracking from '@vromo/analytics';

import findLast from 'lodash/findLast';

interface IProps {
    jobs?: Job[];
    highlighted: boolean;
}

const Cell: FC<IProps> = ({ jobs = [], highlighted }) => {
    const [open, setOpen] = useState(false);
    const [selected, setSelected] = useState([] as number[]);

    const {
        authStore: { graph, role }
    } = useStore<RootStore>('rootStore');

    function unassign() {
        graph.root
            .graph()
            .roles(role.id)
            .jobs()
            .post(
                jobs
                    .filter((job) => selected.includes(job.id))
                    .map((job) => ({
                        id: job.id,
                        dispatches: [{ type: 'returned', vehicle: { id: job.vehicle } }]
                    }))
            )
            .then(() => {
                Tracking.track('Planning View Cell Opened');
                jobs.filter((job) => selected.includes(job.id!)).forEach((job) => {
                    update(job, {
                        status: 'open',
                        dispatches: {
                            type: 'create',
                            items: [
                                {
                                    type: 'returned',
                                    vehicle: { id: job.vehicle }
                                }
                            ]
                        }
                    });
                });

                setOpen(false);
            });
    }

    if (jobs && jobs.length) {
        return (
            <>
                <div
                    onClick={() => setOpen(!open)}
                    style={{
                        position: 'relative',
                        border: `1px solid ${highlighted ? 'orange' : theme.secondary}`,
                        width: 24,
                        height: 24,
                        backgroundColor: theme.secondary,
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'white'
                    }}>
                    {jobs.length > 1 ? jobs.length : ''}
                </div>
                {open ? (
                    <Modal isOpen={true} onRequestClose={() => setOpen(false)}>
                        <Button disabled={!selected.length} onClick={unassign}>
                            Unassign
                        </Button>

                        <table>
                            <thead>
                                <tr style={{ textAlign: 'left' }}>
                                    <th />
                                    <th>Name</th>

                                    <th>First Deadline</th>
                                    <th>Last Deadline</th>

                                    <th>First Stop</th>
                                    <th>Last Stop</th>

                                    <th>Order Cost</th>

                                    <th>Contact Name</th>
                                </tr>
                            </thead>
                            <tbody>
                                {jobs.map((it) => {
                                    const jobDeadlines = it.tasks.map((t) => t?.timeframe?.by);
                                    const firstDeadline = jobDeadlines.find((d) => d !== null);
                                    const lastDeadline = findLast(jobDeadlines, (d) => d !== null);
                                    return (
                                        <tr key={it.id}>
                                            <td>
                                                <input
                                                    type="checkbox"
                                                    checked={selected.includes(it.id!)}
                                                    onChange={(e) => {
                                                        if (e.target.checked) {
                                                            setSelected([...selected, it.id!]);
                                                        } else {
                                                            setSelected(
                                                                selected.filter((i) => i !== it.id)
                                                            );
                                                        }
                                                    }}
                                                />
                                            </td>
                                            <td>{it.name}</td>
                                            <td>
                                                {firstDeadline
                                                    ? format(firstDeadline, 'hh:mma DD MMM YYYY')
                                                    : 'ASAP'}
                                            </td>
                                            <td>
                                                {lastDeadline
                                                    ? format(lastDeadline, 'hh:mma DD MMM YYYY')
                                                    : 'ASAP'}
                                            </td>
                                            <td>
                                                {it.tasks.first()
                                                    ? it.tasks.first()!.zone?.address
                                                    : ''}
                                            </td>
                                            <td>
                                                {it.tasks.last() && it.tasks.length > 1
                                                    ? it.tasks.last()!.zone?.address
                                                    : ''}
                                            </td>
                                            <td>
                                                {it.attr &&
                                                it.attr.items.find((it) =>
                                                    it.key!.match(/order cost/i)
                                                )
                                                    ? it.attr.items.find((it) =>
                                                          it.key!.match(/order cost/i)
                                                      )!.value
                                                    : ''}
                                            </td>
                                            <td>
                                                {it.contact && it.contact.name
                                                    ? it.contact.name
                                                    : ''}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </Modal>
                ) : null}
            </>
        );
    } else {
        return (
            <div
                style={{
                    border: `1px solid ${highlighted ? 'orange' : theme.secondary}`,
                    width: 24,
                    height: 24,
                    backgroundColor: 'transparent'
                }}
            />
        );
    }
};

export default Cell;
